/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Helper = {
  getCategoryTotal: function getCategoryTotal() {
    var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var categoryTotal = 0;
    properties.forEach(function (p) {
      if (typeof p.price === 'number') {
        categoryTotal += p.price || 0;
      }
    });
  },
  shouldDisplayCategory: function shouldDisplayCategory(category) {
    var childCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var _a, _b;

    if (childCategories.length > 0) {
      return true;
    }

    if (category) {
      return ((_a = category === null || category === void 0 ? void 0 : category.display) === null || _a === void 0 ? void 0 : _a.hide) !== false && !!((_b = category === null || category === void 0 ? void 0 : category.attributes) === null || _b === void 0 ? void 0 : _b.length);
    }

    return false;
  }
};
exports.default = Helper;